const NAME = 'COMMON';

export const languages = (store) => store[NAME].languages.data || [];
